import _ from 'lodash';

const ligthTheme = {
  backgroundColor: 'white',
  color: '#646777'
};

const darkTheme = {
  backgroundColor: '#2e2c34',
  color: '#dddddd'
};

export const getTooltipStyles = (themeName, type) => {
  switch (themeName) {
    case 'theme-dark': {
      const { backgroundColor, color } = darkTheme;
      return {
        contentStyle: { backgroundColor },
        itemStyle: type === 'defaultItems' ? null : { color }
      };
    }
    case 'theme-light': {
      return ligthTheme;
    }
    default:
      return ligthTheme;
  }
};

export const convertData = data => {
  const newData = [];
  _.map(data, (d, paymentType) => {
    if (paymentType !== 'details') {
      _.map(d, (p, index) => {
        if (!newData[index]) {
          newData[index] = {
            [paymentType]: p.cumulDaily,
            date: p.date
          };
        } else {
          newData[index][paymentType] = p.cumulDaily;
        }
      });
    }
  });
  return newData;
};
